import { Icon, stenaArrowRightAngle } from '@stenajs-webui/elements';

export function Arrow() {
  return (
    <Icon
      size={20}
      icon={stenaArrowRightAngle}
      style={{ paddingBottom: '8px', paddingTop: '36px' }}
    />
  );
}
